import { render } from "./Information.vue?vue&type=template&id=0ecc7985&scoped=true"
import script from "./Information.vue?vue&type=script&lang=js"
export * from "./Information.vue?vue&type=script&lang=js"

import "./Information.vue?vue&type=style&index=0&id=0ecc7985&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-0ecc7985"

export default script